import React from 'react';
import './AboutHero.css';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/cartSlice';
import { translations } from '../utils/translations';

const AboutHero = () => {
  const selectedLang = useSelector(selectLanguage) || { code: 'en' };
  const t = translations[selectedLang.code || 'en'] || translations.en;

  const path = window.location.pathname;
  const hash = window.location.hash;
  const isContact = path === '/contact-us' || hash === '#/contact-us';
  const isLogin = path === '/login' || hash === '#/login';
  const isRegister = path === '/register' || hash === '#/register' || path === '/signup' || hash === '#/signup';
  const isWarranty = path === '/warranty-policy' || hash === '#/warranty-policy' || path === '/warranty' || hash === '#/warranty';

  let pageTitle = t.aboutUs;
  if (isContact) pageTitle = t.contactUs;
  else if (isLogin) pageTitle = t.signIn;
  else if (isRegister) pageTitle = t.createAccount;
  else if (isWarranty) pageTitle = t.warrantyPolicy || 'Warranty Policy';

  return (
    <section className="about-hero-container">
      {/* Decorative Dot Patterns */}
      <div className="dot-pattern dot-pattern-left">
        <svg width="100" height="80" viewBox="0 0 100 80" fill="none">
          <circle cx="10" cy="10" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="30" cy="10" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="50" cy="10" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="70" cy="10" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="20" cy="25" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="40" cy="25" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="60" cy="25" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="80" cy="25" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="10" cy="40" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="30" cy="40" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="50" cy="40" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="20" cy="55" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="40" cy="55" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="30" cy="70" r="2" fill="#BEB4D6" opacity="0.6"/>
        </svg>
      </div>

      <div className="dot-pattern dot-pattern-right">
        <svg width="100" height="80" viewBox="0 0 100 80" fill="none">
          <circle cx="90" cy="70" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="70" cy="70" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="50" cy="70" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="30" cy="70" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="80" cy="55" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="60" cy="55" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="40" cy="55" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="20" cy="55" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="90" cy="40" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="70" cy="40" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="50" cy="40" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="80" cy="25" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="60" cy="25" r="2" fill="#BEB4D6" opacity="0.6"/>
          <circle cx="70" cy="10" r="2" fill="#BEB4D6" opacity="0.6"/>
        </svg>
      </div>

      <div className="about-hero-content-centered">
        <h1 className="about-hero-title-centered">{pageTitle}</h1>
        <nav className="about-hero-breadcrumbs-centered">
          <span className="breadcrumb-home-link" onClick={() => {
            window.history.pushState({}, '', '/');
            window.dispatchEvent(new PopStateEvent('popstate'));
          }}>{t.home}</span>
          <span className="breadcrumb-separator-char">/</span>
          <span className="breadcrumb-current-text">{pageTitle}</span>
        </nav>
      </div>
    </section>
  );
};

export default AboutHero;
